import React, { Component } from 'react'

import styled from 'styled-components'
import Helmet from 'react-helmet'
import LayoutContainer from '../components/LayoutContainer'
import YoutubeEmbedVideo from 'youtube-embed-video'
import Button from '../components/CustomButtons/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import withStyles from '@material-ui/core/styles/withStyles'
import CustomInput from '../components/CustomInput/CustomInput.jsx'
import CloudDownload from '@material-ui/icons/CloudDownload'
import kebabCase from 'lodash/kebabCase'

import Grid from '@material-ui/core/Grid'
import GridItem from '../components/Grid/GridItem.jsx'

import modalStyle from '../assets/jss/material-kit-pro-react/modalStyle'
import Whitepaper from '../components/Form/Whitepaper'

function Transition(props) {
  return <Slide direction="down" {...props} />
}

class WhoWeArePage extends Component {
  constructor() {
    super()
    this.state = {
      whitepaperModal: false,
      windowWidth: 1920,
    }
  }

  componentDidMount() {
    this.setState({ windowWidth: window.innerWidth })
  }

  render() {
    const pageEdges = this.props.data.page.edges[0]
    const pageData = pageEdges.node.frontmatter
    const { classes } = this.props
    return (
      <LayoutContainer>
        <WWAContainer>
          <Helmet title={pageData.title} />
          <div>
            <h2>{pageData.title}</h2>
            <h4 style={{ color: 'black' }}>
              <strong>{pageData.subtitle}</strong>
            </h4>
          </div>
          {pageData.section.map((section, i) => (
            <SectionContainer>
              <div>
                <h2 id={kebabCase(section.title)} style={{ marginTop: 0 }}>
                  {section.title}
                </h2>
                {i === 0 && (
                  <Button
                    onClick={() => this.setState({ whitepaperModal: true })}
                    round
                    color="info"
                  >
                    <ButtonText>Whitepaper</ButtonText>
                  </Button>
                )}
              </div>
              <div>
                <p>{section.body}</p>
              </div>
            </SectionContainer>
          ))}
          <VideoContainer>
            <div>
              <h4>{pageData.video.body}</h4>
            </div>
            <div>
              <YoutubeEmbedVideo
                suggestions={false}
                showInfo={false}
                videoId={pageData.video.id}
                width={this.state.windowWidth <= 768 ? 250 : 500}
                height={this.state.windowWidth <= 768 ? 140.625 : 281.25}
              />
            </div>
          </VideoContainer>
        </WWAContainer>
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal,
          }}
          TransitionComponent={Transition}
          onClose={() => this.setState({ whitepaperModal: false })}
          open={this.state.whitepaperModal}
        >
          <DialogTitle className={classes.modalHeader}>
            Download Whitepaper
          </DialogTitle>
          <DialogContent className={classes.modalBody}>
            <Whitepaper />
          </DialogContent>
        </Dialog>
      </LayoutContainer>
    )
  }
}

const ButtonText = styled.span`
  color: ${p => p.theme.colors.blue};
  font-weight: bold;
`

const WWAContainer = styled.div`
  padding: ${p => p.theme.col()} ${p => p.theme.col(2)};

  @media screen and (max-width: 768px) {
    padding: 100px ${p => p.theme.col(2)};
  }
`

const SectionContainer = styled.div`
  padding: ${p => p.theme.col()} ${p => p.theme.col(2)};
  display: grid;
  grid-template-columns: 5fr 10fr;
  grid-gap: ${p => p.theme.col(0.5)} ${p => p.theme.col()};

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 50px 0;
  }
`

const VideoContainer = styled(SectionContainer)`
  padding-bottom: 0;
  display: block;
  margin: 0 auto;
  text-align: center;

  > div:last-child {
    @media screen and (max-width: 1200px) {
      position: relative;
      padding-bottom: 56.25%;
      padding-top: 30px;
      height: 0;
      overflow: hidden;
    }

    iframe {
      @media screen and (min-width: 1200px) {
        width: 800px;
        height: 450px;
      }
      @media screen and (max-width: 1200px) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
  @media screen and (max-width: 768px) {
    > div {
      box-sizing: border-box;
    }
  }
`

export const WhoWeAreQuery = graphql`
  query WhoWeAreQuery {
    page: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "who-we-are-page" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            subtitle
            section {
              title
              body
            }
            video {
              body
              id
            }
          }
        }
      }
    }
  }
`

export default withStyles(modalStyle)(WhoWeArePage)



// WEBPACK FOOTER //
// ./src/pages/whoweare.jsx